// components/SignaturePage.tsx
import React from 'react';
import {
	Document,
	Page,
	Text,
	View,
	StyleSheet,
	Font,
} from '@react-pdf/renderer';

Font.register({
	family: 'Praise',
	src: '/fonts/Praise-Regular.ttf',
});

// Estilos
const styles = StyleSheet.create({
	page: {
		flexDirection: 'column',
		backgroundColor: '#FFFFFF',
		padding: 30,
		fontSize: 10,
		fontFamily: 'Helvetica',
	},
	section: {
		margin: 10,
		padding: 16,
		border: '1px solid #CCCCCC',
		borderRadius: 16,
		width: 400,
		marginHorizontal: 'auto',
	},
	title: {
		fontSize: 14,
		marginBottom: 10,
		fontWeight: 'semibold',
	},
	row: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 8,
		justifyContent: 'space-between',
		marginTop: 4,
	},
	label: {
		fontSize: 12,
		color: '#6E6A73',
		textTransform: 'capitalize',
	},
	value: {
		fontSize: 12,
		color: '#0D0616',
		marginTop: 4,
	},
	signatureName: {
		fontSize: 27,
		fontWeight: 'bold',
		color: '#0D0616',
		fontFamily: 'Praise',
		width: '100%',
		textAlign: 'left',
	},
});

interface SignatureData {
	// Document Information
	documentType?: string;
	created?: string;
	signed?: string;
	timestamp?: string;

	// Session Information
	userId?: string;
	country?: string;
	device?: string;
	browser?: string;
	os?: string;
	ip?: string;

	// Signature
	name?: string;
	signature?: string;
}

interface PlaintiffData {
	question: string;
	id: string;
	response: string;
}

interface SignaturePageProps {
	data: SignatureData | undefined;
	plaintiffInfo: PlaintiffData[];
}

const SignaturePage: React.FC<SignaturePageProps> = ({
	data,
	plaintiffInfo,
}) => (
	<Document>
		<Page size="A4" style={styles.page}>
			{data && (
				<>
					<View style={styles.section}>
						<Text style={styles.title}>Document Information</Text>

						<View style={styles.row}>
							<Text style={styles.label}>Document Type:</Text>
							<Text style={styles.value}>{data.documentType}</Text>
						</View>

						<View style={styles.row}>
							<Text style={styles.label}>Created:</Text>
							<Text style={styles.value}>{data.created}</Text>
						</View>
						{data?.signed && (
							<View style={styles.row}>
								<Text style={styles.label}>Signed:</Text>
								<Text style={styles.value}>{data.signed}</Text>
							</View>
						)}

						<View style={styles.row}>
							<Text style={styles.label}>Timestamp:</Text>
							<Text style={styles.value}>{data.timestamp}</Text>
						</View>
					</View>
				</>
			)}

			{/* Signature Section */}
			{((plaintiffInfo && plaintiffInfo.length > 0) || data?.signature) && (
				<View style={styles.section}>
					{plaintiffInfo.length > 0 && (
						<>
							<Text style={styles.title}>Plaintiff Information</Text>
							{plaintiffInfo.map((p, index) => (
								<View key={index} style={styles.row}>
									<Text style={styles.label}>{p.question}</Text>
									<Text style={styles.value}>{p.response}</Text>
								</View>
							))}
						</>
					)}
					{data?.signature && (
						<View
							style={{
								display: 'flex',
								flexDirection: 'row',
								gap: 4,
								marginBottom: 5,
								alignItems: 'center',
							}}
						>
							<Text style={styles.value}>/s/</Text>
							<Text style={styles.signatureName}>{data.signature}</Text>
						</View>
					)}
				</View>
			)}
		</Page>
	</Document>
);

export default SignaturePage;
